// extracted by mini-css-extract-plugin
export default {"Badge":"Badge_Badge__kGkhF","BadgeLavender":"Badge_BadgeLavender__idl9I","BadgeNeutral":"Badge_BadgeNeutral__1XVvx","BadgeNeutralCompact":"Badge_BadgeNeutralCompact__cGPAj"};